import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Power, Lightbulb, Calendar, Brain } from 'lucide-react';
// The four core capabilities, rendered as a clean cell grid with hairline
// dividers and bare orange outline icons (no filled tiles) — matching the
// reference feature-grid treatment while keeping exactly four items.
const CAPABILITIES = [{
  id: 'always-on',
  title: 'Works while you sleep',
  desc: 'Giga works around the clock handling tasks on your behalf: scheduled jobs and recurring actions.',
  icon: Power
}, {
  id: 'memory',
  title: 'Never repeat yourself',
  desc: 'Every conversation, every preference, every goal, carried across sessions. Giga picks up where it left off and refines its own rules.',
  icon: Lightbulb
}, {
  id: 'schedule',
  title: 'It works on a schedule',
  desc: 'Daily reports, weekly digests, all on autopilot. In your channel before you ask.',
  icon: Calendar
}, {
  id: 'learns',
  title: 'It learns your company',
  desc: 'It remembers your decisions and preferences, so you never repeat yourself.',
  icon: Brain
}];
export function CapabilityGrid() {
  return <section className="w-full bg-[#FAF8F4] py-24 md:py-32" data-id="element-550">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-551">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16 md:mb-20" data-id="element-552">
          <span className="block text-xs font-semibold tracking-[5px] uppercase text-neutral-400 mb-5 md:mb-6" data-id="element-553">
            Action over answers
          </span>
          <h2 className="text-3xl md:text-5xl font-title font-medium text-[#2B211A] tracking-tight leading-[1.1] md:whitespace-nowrap" data-id="element-554">
            Built to do the work — not just talk about it.
          </h2>
        </div>

        {/* Cell grid with ONLY the inner hairline dividers — no outer frame.
           Borders are applied per-cell so the outer top/bottom/left/right
           edges stay open and only the inner cross (and mobile stacked
           dividers) remain. */}
        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2" data-id="element-555">
          {CAPABILITIES.map((cap, index) => {
          const Icon = cap.icon;
          // Inner-only dividers:
          // - bottom border on the top row (index 0,1) draws the horizontal
          //   inner line on desktop; on mobile, every item but the last gets
          //   a bottom border so stacked items stay separated.
          // - right border on the left column (index 0,2) draws the vertical
          //   inner line on desktop only.
          const dividerClasses = [index < 3 ? 'border-b border-neutral-200/70' : '', index >= 2 ? 'sm:border-b-0' : '', index % 2 === 0 ? 'sm:border-r sm:border-neutral-200/70' : ''].filter(Boolean).join(' ');
          return <motion.div key={cap.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index % 2 * 0.1
          }} className={`flex flex-col items-start text-left ${dividerClasses} px-8 py-10 md:px-12 md:py-14`} data-id="element-556">
                <Icon strokeWidth={1.75} className="w-9 h-9 text-[#EA580C] mb-8" data-id="element-557" />
                <h3 className="text-xl md:text-2xl font-bold mb-3 text-[#2B211A] tracking-tight" data-id="element-558">
                  {cap.title}
                </h3>
                <p className="leading-relaxed text-[15px] md:text-base text-neutral-500 max-w-sm" data-id="element-559">
                  {cap.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}